import consts from './consts'

export default {
  agencies: state => state.agencies || [],
  companies: state => state.companies || [],
  selectedAgency: state => state.selectedAgency,
  selectedCompany: state => state.selectedCompany,
  sidebarVisible: state => state.sidebarVisible,
  currentTabId: state => state.currentTabId,
  isDebugMode: state => state.isDebugMode,
  isBasis: state => state.currentTabId === consts.BASE_DATA,
  isOutput: state => state.currentTabId > consts.CONTRACT_ANALYSIS,
  isVertrag: state => state.currentTabId === consts.CONTRACT_ANALYSIS,
  isStatus: state => state.currentTabId === consts.STATUS_TALK,
  isConcept: state => state.currentTabId === consts.CONCEPT,
  isLoading: state => state.isLoading === true,
  openGroups: state => state.openGroups || [],
  openSubSections: state => state.openSubSections || [],
  showEmptyNotice: state => state.showEmptyNotice || false,
  showCustomerPref: state => state.showCustomerPref || false,
  isConceptEdit: state => state.isConceptEdit || false,
  hasConcept: state => state.hasConcept || false,
  consultationId: state => state.consultationId || 0,
  countries: () => [
    'Afghanistan',
    'Ägypten',
    'Albanien',
    'Algerien',
    'Andorra',
    'Angola',
    'Antigua und Barbuda',
    'Äquatorialguinea',
    'Argentinien',
    'Armenien',
    'Aserbaidschan',
    'Äthiopien',
    'Australien',
    'Bahamas',
    'Bahrain',
    'Bangladesch',
    'Barbados',
    'Belarus',
    'Belgien',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivien, Plurinationaler Staat',
    'Bosnien und Herzegowina',
    'Botsuana',
    'Brasilien',
    'Brunei Darussalam',
    'Bulgarien',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Chile',
    'China',
    'Cookinseln',
    'Costa Rica',
    `Côte d'Ivoire`,
    'Dänemark',
    'Deutschland',
    'Dominica',
    'Dominikanische Republik',
    'Dschibuti',
    'Ecuador',
    'El Salvador',
    'Eritrea',
    'Estland',
    'Eswatini',
    'Fidschi',
    'Finnland',
    'Frankreich',
    'Gabun',
    'Gambia',
    'Georgien',
    'Ghana',
    'Grenada',
    'Griechenland',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heiliger Stuhl',
    'Honduras',
    'Indien',
    'Indonesien',
    'Irak',
    'Iran, Islamische Republik',
    'Irland',
    'Island',
    'Israel',
    'Italien',
    'Jamaika',
    'Japan',
    'Jemen',
    'Jordanien',
    'Kambodscha',
    'Kamerun',
    'Kanada',
    'Kasachstan',
    'Katar',
    'Kenia',
    'Kirgisistan',
    'Kiribati',
    'Kolumbien',
    'Komoren',
    'Kongo',
    'Kongo, Demokratische Republik',
    'Korea, Demokratische Volksrepublik',
    'Korea, Republik',
    'Kosovo',
    'Kroatien',
    'Kuba',
    'Kuwait',
    'Laos, Demokratische Volksrepublik',
    'Lesotho',
    'Lettland',
    'Libanon',
    'Liberia',
    'Libyen',
    'Liechtenstein',
    'Litauen',
    'Luxemburg',
    'Madagaskar',
    'Malawi',
    'Malaysia',
    'Malediven',
    'Mali',
    'Malta',
    'Marokko',
    'Marshallinseln',
    'Mauretanien',
    'Mauritius',
    'Mexiko',
    'Mikronesien, Föderierte Staaten von',
    'Moldau, Republik',
    'Monaco',
    'Mongolei',
    'Montenegro',
    'Mosambik',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Neuseeland',
    'Nicaragua',
    'Niederlande',
    'Niger',
    'Nigeria',
    'Niue',
    'Nordmazedonien',
    'Norwegen',
    'Oman',
    'Österreich',
    'Pakistan',
    'Palau',
    'Panama',
    'Papua-Neuguinea',
    'Paraguay',
    'Peru',
    'Philippinen',
    'Polen',
    'Portugal',
    'Ruanda',
    'Rumänien',
    'Russische Föderation',
    'Salomonen',
    'Sambia',
    'Samoa',
    'San Marino',
    'São Tomé und Príncipe',
    'Saudi-Arabien',
    'Schweden',
    'Schweiz',
    'Senegal',
    'Serbien',
    'Seychellen',
    'Sierra Leone',
    'Simbabwe',
    'Singapur',
    'Slowakei',
    'Slowenien',
    'Somalia',
    'Spanien',
    'Sri Lanka',
    'St. Kitts und Nevis',
    'St. Lucia',
    'St. Vincent und die Grenadinen',
    'Südafrika',
    'Sudan',
    'Südsudan',
    'Suriname',
    'Syrien, Arabische Republik',
    'Tadschikistan',
    'Tansania, Vereinigte Republik',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad und Tobago',
    'Tschad',
    'Tschechien',
    'Tunesien',
    'Türkei',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'Ungarn',
    'Uruguay',
    'Usbekistan',
    'Vanuatu',
    'Vatikanstadt',
    'Venezuela, Bolivarische Republik',
    'Vereinigte Arabische Emirate',
    'Vereinigte Staaten',
    'Vereinigtes Königreich',
    'Vietnam',
    'Weißrussland',
    'Zentralafrikanische Republik',
    'Zypern',
  ]
}
